import React from 'react';

const Loader = () => {
  return (
    <img
      src={`/client/icons/loader.gif`}
      alt='Loading...'
    />
  );
};

export default Loader;
